
import { Placement } from '@post-office/placements-frontend/townsquare-side-nav';
export default Placement;
